"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isValidDate;

function isValidDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof date !== 'string') {
    return false;
  }

  if (date.length !== 10) {
    return false;
  }

  var parsed = Date.parse(date); // If the parsed date is a valid number, then the date is valid

  return !Number.isNaN(parsed);
}